@if (confirm.pending(); as c) {
  <div class="modal-backdrop confirm-backdrop">
    <div
      class="modal confirm-modal"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-message"
    >
      <div class="modal-header">
        <h3 id="confirm-title">{{ c.title }}</h3>
      </div>

      <div class="modal-body">
        <p id="confirm-message" class="confirm-message">{{ c.message }}</p>
        @if (c.detail) {
          <div class="confirm-detail" [class.danger]="c.danger">{{ c.detail }}</div>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="confirm.resolve(false)">
          {{ c.cancelLabel }}
        </button>
        <button
          #confirmButton
          type="button"
          class="btn"
          [class.btn-danger]="c.danger"
          [class.btn-primary]="!c.danger"
          (click)="confirm.resolve(true)"
        >
          {{ c.confirmLabel }}
        </button>
      </div>
    </div>
  </div>
}
